import React from 'react';
import TravelServicePage from './TravelServicePage';

const carsConfig = {
  name: 'Car Rentals',
  tagline: 'Unlock wheels that match your mood',
  description:
    'From executive sedans to sunset convertibles, reserve vehicles that sync with your itinerary and sustainability goals.',
  heroImage: 'https://images.unsplash.com/photo-1503736334956-4c8f8e92946d?w=1600',
  accent: '#22c55e',
  metrics: [
    { value: '210', label: 'city fleets' },
    { value: '4.9★', label: 'driver rating average' },
    { value: '0%', label: 'hidden surcharges' }
  ],
  highlights: [
    {
      icon: '🚗',
      title: 'Adaptive fleet',
      description: 'Choose EVs, SUVs, or luxe rides with real-time availability synced to airport arrivals.'
    },
    {
      icon: '🛰️',
      title: 'Route intelligence',
      description: 'We preload detours, fuel stops, and scenic suggestions based on your trip personality.'
    },
    {
      icon: '🧾',
      title: 'Expense happy',
      description: 'Transparent billing with instant invoices that plug directly into your expense tools.'
    }
  ],
  journey: [
    {
      title: 'Set your drive DNA',
      description: 'Tell us if you’re chasing coastlines, investor meetings, or mountain air—we curate the vibe.'
    },
    {
      title: 'Reserve in milliseconds',
      description: 'Hold or confirm vehicles with one swipe, and auto-upgrade if your hotel concierge spots an opening.'
    },
    {
      title: 'Stay in the loop',
      description: 'Live maps, damage reports, and fueling reminders arrive before you ever need to ask.'
    },
    {
      title: 'Glide through returns',
      description: 'Touchless drop-off, instant receipts, and loyalty points credited instantly.'
    }
  ],
  testimonials: [
    {
      quote:
        'The executive fleet alerts are incredible—we secure premium sedans for our VIPs without frantic phone calls.',
      name: 'Miriam Walsh',
      role: 'Chief of Staff, Orbit Labs'
    },
    {
      quote:
        'Loved how the route suggestions fit our foodie tour. Charging stops were already mapped—zero stress.',
      name: 'Kenji & Mei',
      role: 'Weekend Explorers'
    }
  ],
  cta: {
    title: 'Hit the road the InnBotics way',
    description: 'Bundle your ride with rooms, flights, and experiences. One itinerary, infinite freedom.',
    actions: [
      { label: 'Reserve a car', href: '/booking', primary: true },
      { label: 'View hotel stays', href: '/rooms', primary: false }
    ]
  }
};

const CarsPage = () => <TravelServicePage config={carsConfig} />;

export default CarsPage;
